import { render } from "./TermCondition.vue?vue&type=template&id=c614bb5c"
import script from "./TermCondition.vue?vue&type=script&lang=js"
export * from "./TermCondition.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__